import React, { useContext } from 'react';
import { ArrowRight } from 'lucide-react';
import { NavigationContext } from '../App';
// Product images from Christiana's collection
const IMAGES = {
  blackPeplum: 'https://cdn.magicpatterns.com/uploads/k3nbovxYYDH3962AQgD28u/photo_2026-02-04_04-57-03.jpg',
  brownPleated: 'https://cdn.magicpatterns.com/uploads/dyohvQLDScUhskTJ884wYi/photo_2026-02-04_04-57-01.jpg',
  purpleFringe: 'https://cdn.magicpatterns.com/uploads/rrAJzJnT1RaD9iNVi3fG4e/photo_2026-02-04_04-57-00.jpg',
  tealSuit: 'https://cdn.magicpatterns.com/uploads/3hrnMEGcTHukVuERpb86Hi/photo_2026-02-04_04-57-05.jpg',
  greenMaxi: 'https://cdn.magicpatterns.com/uploads/n3jybvjJ42ADZp6V5BmhiN/photo_2026-02-04_04-57-04.jpg'
};
const categories = [{
  id: 1,
  title: 'New Arrivals',
  description: 'Fresh styles for the season',
  image: IMAGES.purpleFringe
}, {
  id: 2,
  title: 'Dresses',
  description: 'Elegant silhouettes for every occasion',
  image: IMAGES.greenMaxi
}, {
  id: 3,
  title: 'Two-Piece Sets',
  description: 'Coordinated elegance',
  image: IMAGES.tealSuit
}];
export function CategoryHighlights() {
  const {
    navigate
  } = useContext(NavigationContext);
  return <section className="py-24 bg-[#FDF8F3] relative" data-id="element-14">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 african-pattern opacity-10" data-id="element-15" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="text-center mb-14" data-id="element-17">
          <p className="text-sm sm:text-base uppercase tracking-[0.2em] text-[#6B5B4F] mb-3 font-['Raleway']" data-id="element-18">
            Explore
          </p>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-['Playfair_Display'] text-[#5C3D2E]" data-id="element-19">
            Shop by Category
          </h2>
          <div className="w-14 h-[2px] bg-[#D4A853] mx-auto mt-5" data-id="element-20" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-21">
          {categories.map(category => <div key={category.id} onClick={() => navigate('shop')} className="group relative overflow-hidden cursor-pointer" data-id="element-22">
              <div className="w-full aspect-[3/4] relative overflow-hidden" data-id="element-23">
                <img src={category.image} alt={category.title} className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105" data-id="element-24" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#5C3D2E]/90 via-[#5C3D2E]/40 to-transparent" data-id="element-25" />
              </div>

              <div className="absolute bottom-0 left-0 w-full p-8 lg:p-10" data-id="element-26">
                <h3 className="text-2xl lg:text-3xl font-['Playfair_Display'] text-white mb-3" data-id="element-27">
                  {category.title}
                </h3>
                <div className="flex items-center text-sm font-medium text-[#D4A853] uppercase tracking-[0.15em] group-hover:text-white transition-colors" data-id="element-28">
                  Browse
                  <ArrowRight size={16} className="ml-2 transform group-hover:translate-x-1 transition-transform" strokeWidth={1.5} data-id="element-29" />
                </div>
              </div>

              {/* Decorative corner accent */}
              <div className="absolute top-4 right-4 w-10 h-10 border-t-2 border-r-2 border-[#D4A853]/50 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-30" />
            </div>)}
        </div>
      </div>
    </section>;
}